import { useState, useEffect, useCallback } from 'react'
import { UseEstatisticasOptions, EstatisticasOrcamento, ApiResponse } from '../types';


export const useEstatisticas = (options: UseEstatisticasOptions) => {
  const [stats, setStats] = useState<EstatisticasOrcamento | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // 🔥 AQUI ACONTECE A CHAMADA DA API!
  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      console.log('🔄 Fazendo requisição para:', `${options.appsScriptUrl}?action=stats`);

      // 📡 CHAMADA HTTP PARA O APPS SCRIPT
      const response = await fetch(`${options.appsScriptUrl}?action=stats`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // 📊 CONVERTENDO A RESPOSTA PARA JSON
      const result: ApiResponse<EstatisticasOrcamento> = await response.json();
      
      console.log('✅ Resposta recebida:', result);
      
      if (result.success && result.data) {
        setStats(result.data); // 💾 Salvando no estado
      } else {
        throw new Error(result.error || 'Erro desconhecido na API');
      }
      
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao buscar estatísticas';
      setError(errorMessage);
      console.error('❌ Erro ao buscar estatísticas:', err);
    } finally {
      setLoading(false);
    }
  }, [options.appsScriptUrl]);

  // 🔄 EXECUTA A PRIMEIRA VEZ E CONFIGURA AUTO-UPDATE
  useEffect(() => {
    console.log('🚀 Hook iniciado, fazendo primeira requisição...');
    fetchStats(); // Primeira chamada

    if (options.autoUpdate) {
      console.log(`⏰ Configurando auto-update a cada ${options.updateInterval}ms`);
      const interval = setInterval(fetchStats, options.updateInterval);
      return () => {
        console.log('🛑 Limpando intervalo de auto-update');
        clearInterval(interval);
      };
    }
  }, [fetchStats, options.autoUpdate, options.updateInterval]);

  // 🎯 ATUALIZAR QUANDO A PÁGINA GANHAR FOCO
  useEffect(() => {
    const handleFocus = () => {
      if (!loading) {
        console.log('👁️ Página ganhou foco, atualizando dados...');
        fetchStats();
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [fetchStats, loading]);

  return {
    stats,     // 📊 Dados recebidos da API
    loading,   // ⏳ Estado de carregamento  
    error,     // ❌ Erro se houver
    refetch: fetchStats // 🔄 Função para atualizar manualmente
  };
};
